module.exports = function keywordAutoLink(md) {
  md.core.ruler.push('autolink', function replaceAutoLink(state, silent) {
    if (silent) {
      return false;
    }

    if (!state.env.autolink || !state.env.autolink.addLinkToMarkdownIt) {
      return false;
    }

    function parse(tokens, state) {
      const result = [];
      const allowAutoLinkTags = ['p', 'section', 'ul', 'li', 'td', 'th', 'table', 'tr', 'tbody'];

      for (let i = 0; i < tokens.length; i++) {
        const current = tokens[i];
        if (current.type === 'inline') {
          current.children = parse(current.children, state);
          result.push(current);
          continue;
        }

        if (current.nesting === 1 && !allowAutoLinkTags.includes(current.tag)) {
          do {
            result.push(tokens[i]);
            i++;
          } while (tokens[i].level !== current.level && tokens[i].nesting !== -1);
          result.push(tokens[i]);
          continue;
        }

        if (current.type !== 'text') {
          result.push(current);
          continue;
        }

        state.env.autolink.addLinkToMarkdownIt(state.env.game, current, state.env.referrerUrl, state).forEach((t) => {
          result.push(t);
        });
      }

      return result;
    }

    state.tokens = parse(state.tokens, state);
  });
};
